import { call, takeLatest, put } from "redux-saga/effects"
import {
  requestContentByFilters,
  requestTrendingContent,
  requestGetContentDataInRange,
  requestCreateContent,
  requestUpdateContent,
  requestFetchContentByUUIDs,
  requestUpdateTag,
  requestUploadContent,
  requestUploadCsv,
  requestLabelContentList,
  requestLabelContent,
  requestBoostContent,
  requestBoostContentHistory,
  requestUpdateAction,
  requestShoppableCuratedTypes,
  requestGetShoppableCuratedTypes,
  requestUpsertShoppableContent,
  requestTasksByFilters,
  requestAgencyLevelStats,
  requestAgentListByAgency,
  requestUniqueTaggedAndQCTaggedContainData,
  requestLanguageLevelStats,
  requestAgentByLanguage,
  requestUpdateContentZones,
} from "appRedux/sagas/requests/content"
import {
  getContentByFilter,
  getContentByFilterSuccess,
  getTrendingContent,
  getTrendingContentSuccess,
  getContentDataInRange,
  getContentDataInRangeSuccess,
  updateContent,
  updateContentSuccess,
  createContent,
  createContentSuccess,
  fetchContentByUuidsSuccess,
  fetchContentByUuids,
  updateTag,
  uploadContent,
  uploadContentSuccess,
  uploadCsv,
  uploadCsvSuccess,
  getLabelContentList,
  getLabelContentListSuccess,
  labelContent,
  labelContentSuccess,
  boostContent,
  boostContentSuccess,
  getBoostContentHistory,
  getBoostContentHistorySuccess,
  updateAction,
  updateActionSuccess,
  shoppableCuratedTypes,
  shoppableCuratedTypesSuccess,
  getShoppableCuratedTypes,
  getShoppableCuratedTypesSuccess,
  upsertShoppableContent,
  upsertShoppableContentSuccess,
  getContentById,
  getContentByIdSuccess,
  getTasksByFilter,
  getTasksByFilterSuccess,
  getEvents,
  getEventsSuccess,
  getAgencyLevelStats,
  getAgencyLevelStatsSuccess,
  getAgentListByAgency,
  getAgentListByAgencySuccess,
  getUniqueTaggedAndQCTaggedContainData,
  getUniqueTaggedAndQCTaggedContainDataSuccess,
  getLanguageLevelStats,
  getLanguageLevelStatsSuccess,
  getAgentByLanguage,
  getAgentByLanguageSuccess,
  updateContentZones,
  updateContentZonesSuccess,
} from "appRedux/slices/content"
import { fetchError } from "appRedux/slices/common"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import {
  requestGetEvents,
  requestMarkQcTaskAsCompleted,
} from "../requests/content"
import { markQCCompleted, markQCCompletedSuccess } from "../../slices/content"

function* handleGetContentByFilters(params) {
  try {
    const data = yield call(requestContentByFilters, params)
    yield put(getContentByFilterSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetTasksByFilters(params) {
  try {
    const data = yield call(requestTasksByFilters, params)
    yield put(getTasksByFilterSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetContentById(params) {
  try {
    const data = yield call(requestContentByFilters, params)
    yield put(getContentByIdSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetLabelContentList(params) {
  try {
    const data = yield call(requestLabelContentList, params)
    yield put(getLabelContentListSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetTrendingContent(params) {
  try {
    const data = yield call(requestTrendingContent, params)
    yield put(getTrendingContentSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetContentDataInRange(params) {
  try {
    const data = yield call(requestGetContentDataInRange, params)
    yield put(getContentDataInRangeSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleFetchContentByUuids(params) {
  try {
    const data = yield call(requestFetchContentByUUIDs, params)
    yield put(fetchContentByUuidsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpdateContent(params) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestUpdateContent, params)
    yield put(updateContentSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpdateContentZones(params) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestUpdateContentZones, params)
    yield put(updateContentZonesSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpdateAction(params) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestUpdateAction, params)
    yield put(updateActionSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpdateTag(params) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestUpdateTag, params)
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUploadContent(payload) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestUploadContent, payload)
    yield put(uploadContentSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUploadCsv(payload) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestUploadCsv, payload)
    yield put(uploadCsvSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleShoppableCuratedTypes(payload) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestShoppableCuratedTypes, payload)
    yield put(shoppableCuratedTypesSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleUpsertShoppableContent(payload) {
  try {
    yield call(requestUpsertShoppableContent, payload)
    yield put(upsertShoppableContentSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetShoppableCuratedTypes(params) {
  try {
    const data = yield call(requestGetShoppableCuratedTypes, params)
    yield put(getShoppableCuratedTypesSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleLabelContentGenerator(payload) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestLabelContent, payload)
    yield put(labelContentSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleBoostContentGenerator(payload) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestBoostContent, payload)
    yield put(boostContentSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleGetBoostContentHistoryGenerator(payload) {
  try {
    const data = yield call(requestBoostContentHistory, payload)
    yield put(getBoostContentHistorySuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleCreateContentGenerator(payload) {
  try {
    toastr.info("Action in progress...", "")
    yield call(requestCreateContent, payload)
    yield put(createContentSuccess())
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleEventsGenerator(payload) {
  try {
    const data = yield call(requestGetEvents, payload)
    yield put(getEventsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}
function* handleAgencyLevelStatsGenerator(payload) {
  try {
    const data = yield call(requestAgencyLevelStats, payload)
    yield put(getAgencyLevelStatsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}
function* handleAgentListByAgencyGenerator(payload) {
  try {
    const data = yield call(requestAgentListByAgency, payload)
    yield put(getAgentListByAgencySuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}
function* handleUniqueTaggedAndQCTaggedContainDataGenerator(payload) {
  try {
    const data = yield call(requestUniqueTaggedAndQCTaggedContainData, payload)
    yield put(getUniqueTaggedAndQCTaggedContainDataSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}
function* handleLanguageLevelStatsGenerator(payload) {
  try {
    const data = yield call(requestLanguageLevelStats, payload)
    yield put(getLanguageLevelStatsSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}
function* handleAgentByLanguageGenerator(payload) {
  try {
    const data = yield call(requestAgentByLanguage, payload)
    yield put(getAgentByLanguageSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

function* handleMarkQCCompletedGenerator(payload) {
  try {
    toastr.info("Action in progress...", "")
    const data = yield call(requestMarkQcTaskAsCompleted, payload)
    yield put(markQCCompletedSuccess(data))
  } catch (error) {
    yield put(fetchError(error))
  }
}

export default function* watcherSaga() {
  yield takeLatest(getContentByFilter.type, handleGetContentByFilters)
  yield takeLatest(getTasksByFilter.type, handleGetTasksByFilters)
  yield takeLatest(getContentById.type, handleGetContentById)
  yield takeLatest(getLabelContentList.type, handleGetLabelContentList)
  yield takeLatest(getTrendingContent.type, handleGetTrendingContent)
  yield takeLatest(getContentDataInRange.type, handleGetContentDataInRange)
  yield takeLatest(updateContent.type, handleUpdateContent)
  yield takeLatest(updateContentZones.type, handleUpdateContentZones)
  yield takeLatest(updateAction.type, handleUpdateAction)
  yield takeLatest(fetchContentByUuids.type, handleFetchContentByUuids)
  yield takeLatest(updateTag.type, handleUpdateTag)
  yield takeLatest(uploadContent.type, handleUploadContent)
  yield takeLatest(shoppableCuratedTypes.type, handleShoppableCuratedTypes)
  yield takeLatest(createContent.type, handleCreateContentGenerator)
  yield takeLatest(labelContent.type, handleLabelContentGenerator)
  yield takeLatest(boostContent.type, handleBoostContentGenerator)
  yield takeLatest(uploadCsv.type, handleUploadCsv)
  yield takeLatest(
    getShoppableCuratedTypes.type,
    handleGetShoppableCuratedTypes
  )
  yield takeLatest(upsertShoppableContent.type, handleUpsertShoppableContent)
  yield takeLatest(
    getBoostContentHistory.type,
    handleGetBoostContentHistoryGenerator
  )
  yield takeLatest(getEvents.type, handleEventsGenerator)

  yield takeLatest(getAgencyLevelStats.type, handleAgencyLevelStatsGenerator)
  yield takeLatest(getAgentListByAgency.type, handleAgentListByAgencyGenerator)
  yield takeLatest(
    getUniqueTaggedAndQCTaggedContainData.type,
    handleUniqueTaggedAndQCTaggedContainDataGenerator
  )
  yield takeLatest(
    getLanguageLevelStats.type,
    handleLanguageLevelStatsGenerator
  )
  yield takeLatest(getAgentByLanguage.type, handleAgentByLanguageGenerator)
  yield takeLatest(markQCCompleted.type, handleMarkQCCompletedGenerator)
}
